<template>
    <v-list nav dense>
        <template>
            <v-list-item link router to="/historical" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-book-open-page-variant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Historial') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-show="getProfile.idHousingUnit === '2c34ad01-90f3-4540-9263-33707827cbcf'" link router
                to="/historical_no_code" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-book-search</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Historial_avanzado') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/current_invitations" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-calendar-multiselect</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('current_invitations') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/casas" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-home-variant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('casas') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-show="getProfile.staff === true" link router to="/department_manager">
                <v-list-item-action>
                    <v-icon>mdi-account-group</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('department_manager') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/areas" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-domain</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Areas') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/staff" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-face-agent</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        Staff
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/directory" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-bookmark-box-multiple</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('directory') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-group prepend-icon="mdi-golf" no-action color="white">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>Golf</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item link router to="/golf/courts" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-soccer-field</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_courts') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item link router to="/golf/blacklist" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-account-cancel</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_blacklist') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-group sub-group no-action color="white">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Starter</v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item link router to="/golf/reservations" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-calendar-clock</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('golf_reservations') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link router to="/golf/caddies" class="list" active-class="white black--text">
                        <v-list-item-action>
                            <v-icon>mdi-account-tie</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('golf_caddies') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list-group>
            <v-list-item link router to="/sports" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-football</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('sports') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/courts" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-soccer-field</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('courts') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/sports_schedules" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-calendar-range</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('sports_schedules') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/reservation" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-clipboard-text-clock </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('booking') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-show="getProfile.enable_parcel === true" link router to="/parcel" class="list"
                active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-truck</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('parcel') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/financial_statements" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-finance</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('financial_statements') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/notices" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Notices') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-show="getProfile.enable_reports === true" link router to="/reports" class="list"
                active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-alert</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Reports') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!--<v-divider></v-divider>-->
            <!--<v-divider></v-divider>-->
            <v-list-item link router to="/main_residents" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-account-star</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('main_residents') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/account_statements" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-account-cash</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('account_statements') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/workers_admin" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-badge-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('workers') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/guards" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-clipboard-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Vigilantes') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/guardhouses" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-store-24-hour</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Casetas') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item link router to="/settings" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('configuracion') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <!--<v-divider></v-divider>-->
            <v-list-item link router to="/ayuda" class="list" active-class="white black--text">
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ $t('Ayuda') }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'admin',
  computed: {
    ...mapGetters(['getProfile'])
  }
}
</script>

<style scoped>
.list:hover {
    background: white;
    opacity: 0.85;
}
</style>
